import React, { useEffect } from "react";
import { Outlet } from "react-router";
import RedesignNavChrome from "@layouts/RedesignNavChrome";
import Footer from "@pages/HomeRedesign/components/Footer/Footer";
import ScrollToTop from "@components/ScrollToTop/ScrollToTop";
import { observer } from "mobx-react";
import { authStore } from "@stores/main";
import { useBreadcrumbNavigation } from "../utils/breadcrumbNavigation";

const AuthLayout = () => {
  const { goToLogin } = useBreadcrumbNavigation();

  useEffect(() => {
    if (!authStore.isAuthenticated) {
      goToLogin();
    }
  }, [authStore.isAuthenticated]);

  return (
    <React.Fragment>
      <RedesignNavChrome />
      <ScrollToTop />
      {authStore.isAuthenticated && <Outlet />}
      <Footer />
    </React.Fragment>
  );
};

export default observer(AuthLayout);
